class Utils { //Classe de utilidades
    constructor(){ //Singleton
        if (Utils.instance) {
            return Utils.instance;
        }

        Utils.instance = this;
    }
    
    capitalizeString(str) {
        return str
            .split(' ') // Separa a string em palavras
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitaliza a primeira letra de cada palavra
            .join(' '); // Junta as palavras novamente
    }

    removeAccents(palavra) {
        return palavra
            .normalize('NFD') // Normaliza a string para sua forma de decomposição (NFD)
            .replace(/[\u0300-\u036f]/g, ''); // Remove todos os caracteres de acentuação
    }

    containsSpecialChars(str) {
        const specialChars = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g;
        return specialChars.test(str);
    }

    containsSpecialCharsEmail(str) {
        const specialChars = /[\{\}\[\]\/?,;:|\)*~`!^\+<>\#$%&\\\=\(\'\"]/g;
        return specialChars.test(str);
    }

    delay(ms) {
        return new Promise((resolve) => setTimeout((resolve), ms));
    }

    handleString(str){
        const strArray = str.toLowerCase().replace(' - ', ' ').split(' '); //transforma a string em vetor com caracteres minúsculos, retirando os hífens que possa ter.

        const strArrayWithoutAccents = this.removeAccents(strArray.join(' ')); //Juntar vetor de palavras numa única string, sem espaços e acentos. Ex: Título do Produto -> titulo-do-produto
        
        const allowedChars = /[^a-zA-Z0-9\s\-]/g;
        const cleanedStr = strArrayWithoutAccents.replace(allowedChars, ' ').split(' ');

        const dashedWords = cleanedStr.map( //Gera novo vetor com hífens ao fim das palavras
            (title,index)=>{
                if(title === '-'){ //Caso ainda tenha algum hífe, retirar.
                    return '';
                }
                
                if (index === cleanedStr.length - 1) { //Não fazer na última palavra
                    return title;
                }
    
                if(title === ''){
                    return '';
                }

                title += '-'; //Adicionar hífen
                return title;
            }
        );

        return dashedWords.join('');
    }

    numberToMoney(value, currency) {
        // const strValue = value.toFixed(2).replace('.', ',');
        const strValue = this.formatarMoeda(value);        
        return `${currency} ${strValue}`;
    }
    formatarMoeda = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    };

    ceilToTenth(value) {
        return Math.ceil(value * 10) / 10;
    }

    ceilToHundredth(value) {
        return (value - Math.floor(value) > 0.99) ? Math.ceil(value * 20) / 20 : value;
    }

    ceilToFiveCents(value) {
        return Math.ceil(value * 20) / 20;
    }

    
    getJSONData(id) {
        const jsonScript = document.getElementById(`${id}`);
        if(!jsonScript) {
            console.warn(`Product JSON not found for ID: ${id}`);
            return null;
        }

        try{
            return JSON.parse(jsonScript.textContent);
        } catch(e) {
            console.error(e);
            return null;
        }
    }

    focusElement(element, container) {
        if (element) {
            element.focus({ preventScroll: false });
            setTimeout(() => {
            container.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
        } else {
                this.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    getWidth(){
        return window.innerWidth 
            || document.documentElement.clientWidth 
            || document.body.clientWidth 
            || 0;
    }

    getHeight(){
        return window.innerHeight 
            || document.documentElement.clientHeight 
            || document.body.clientHeight 
            || 0;
    }
}